import { Loader, LoaderStyle } from "@repo/ui/Loader/loader";
import type { FC } from "react";
import { appPaths } from "../app/appPaths.js";
import { DefaultPlaybookRedirect } from "../features/links/defaultPlaybookRedirect.js";
import { selectTeammate } from "../features/teammate/teammateSlice.js";
import { useAppSelector } from "../hooks/hook.js";

/**
 * Home page for teammates with the TEAM_MEMBER role. Resolves their default
 * playbook in place and lands on their own teammate page in a single
 * navigation, rather than bouncing through the placeholder playbook URL.
 */
export const TeamMemberHomePage: FC = () => {
  const teammate = useAppSelector(selectTeammate);

  if (!teammate) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader style={LoaderStyle.ZOOMIES} />
      </div>
    );
  }

  return (
    <DefaultPlaybookRedirect
      buildPath={(playbookId) =>
        appPaths.teammate.build({ playbookId, teammateId: teammate.id })
      }
    />
  );
};
